"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebounceCallback = void 0;
const react_1 = require("react");
const useDebounceCallback = (callback, debounceTimeInMs) => {
    const timerIdRef = (0, react_1.useRef)(null);
    const tearDown = () => {
        if (timerIdRef.current) {
            clearTimeout(timerIdRef.current);
            timerIdRef.current = null;
        }
    };
    (0, react_1.useEffect)(() => tearDown, []);
    return (...args) => {
        tearDown();
        if (debounceTimeInMs === 0) {
            callback(...args);
            return;
        }
        timerIdRef.current = window.setTimeout(() => {
            callback(...args);
        }, debounceTimeInMs);
    };
};
exports.useDebounceCallback = useDebounceCallback;
//# sourceMappingURL=useDebounceCallback.js.map